import { render, staticRenderFns } from "./VideoContainer.vue?vue&type=template&id=3b479513&scoped=true&"
import script from "./VideoContainer.vue?vue&type=script&lang=js&"
export * from "./VideoContainer.vue?vue&type=script&lang=js&"
import style0 from "./VideoContainer.vue?vue&type=style&index=0&id=3b479513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b479513",
  null
  
)

export default component.exports